<script setup lang="ts">
import spacing from '#tailwind-config/theme/spacing'

import type Spacing from '~/types/spacing'
import type { StyleRecord } from '~/types/styleRecord'

type Props = {
  padding?: Spacing
  theme?: 'light' | 'dark'
  rounded?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | 'full'
}
type Slots = {
  default(): any
}

const props = withDefaults(defineProps<Props>(), {
  padding: '5',
  theme: 'light',
  rounded: 'xs',
})
defineSlots<Slots>()

const computedStyle = computed<StyleRecord<'padding'>>(() => ({
  padding: spacing[props.padding],
}))

const bgColorClass = computed(() =>
  props.theme === 'dark' ? 'tw-bg-fill-alt tw-text-inverse' : 'tw-bg-white',
)

const borderRadiusClass = computed(() => {
  return `tw-rounded-${props.rounded}`
})
</script>

<template>
  <div
    class="vCardContainer tw-shadow tw-transition-shadow tw-duration-150"
    :class="[bgColorClass, borderRadiusClass]"
    :style="computedStyle"
  >
    <slot />
  </div>
</template>
